import React from 'react';
import { AccommodationList } from '@/components/sections/AccommodationList';

export const AccommodationSection: React.FC = () => {
    return (
        <div id="accommodation" className="bg-[#eee8dc]">
            <AccommodationList />
        </div>
    );
};
